/* Sleeve Stars — Judge.me integration + buy-box rating sync.
   Renders the Judge.me product review widget inside the PDP reviews section
   AND keeps the buy-box rating (.ss-pdp__rating-value + .ss-pdp__rating-count)
   in sync with what Judge.me actually shows. If Judge.me reports zero reviews,
   the buy-box rating block is hidden so the page doesn't claim 11,826 reviews
   when there are none. */
(function () {
  'use strict';

  /* ============================================================
     EARLY CSS — Hide PDP rating block by default.
     Injected synchronously at script-eval time so the rule is in
     the document <head> BEFORE the buy-box paints. The JS below
     unhides it ONLY after Judge.me confirms reviews exist.
     Prevents stale metafield numbers (4.83 / 1,085) from flashing.
     ============================================================ */
  (function injectEarlyHideCSS() {
    if (document.getElementById('ss-pdp-rating-hide-css')) return;
    var s = document.createElement('style');
    s.id = 'ss-pdp-rating-hide-css';
    s.textContent =
      // '.ss-pdp__rating{display:none !important;}' +
      '.ss-pdp__rating[data-ss-rating-synced="1"]{display:flex !important;}';
    (document.head || document.documentElement).appendChild(s);
  })();

  var CSS = (
    '.ss-pc__reviews .ss-pc__rev-summary,' +
    '.ss-pc__reviews .ss-pc__rev-list,' +
    '.ss-pc__reviews .ss-pc__rev-pages,' +
    '.ss-pc__reviews .ss-pc__rev-all{display:none !important;}' +
    '.ss-pc__jdgm-wrap{max-width:1100px;margin:0 auto;padding:0 4px;}' +
    /* Hide Judge.me built-in "Customer Reviews" title — section already has its own heading. */
    '.ss-pc__jdgm-wrap .jdgm-rev-widg__title,' +
    '.ss-pc__jdgm-wrap .jdgm-rev-widg__header > .jdgm-rev-widg__title,' +
    '.ss-pc__jdgm-wrap h2.jdgm-rev-widg__title{display:none !important;}' +
    '.jdgm-widget .jdgm-star,' +
    '.jdgm-widget .jdgm-rev__rating,' +
    '.jdgm-widget .jdgm-prev-badge__stars{color:var(--ss-red,#EC2426) !important;}' +
    '.jdgm-widget .jdgm-rev__buyer-badge,' +
    '.jdgm-widget .jdgm-rev__icon{color:var(--ss-pine,#5A8767) !important;}' +
    '.jdgm-widget .jdgm-paginate__page.jdgm-curt{background:var(--ss-red,#EC2426) !important;color:#fff !important;border-color:var(--ss-red,#EC2426) !important;}' +
    '.jdgm-widget .jdgm-write-rev-link,' +
    '.jdgm-widget .jdgm-rev__br-btn,' +
    '.jdgm-widget .jdgm-btn{background:var(--ss-red,#EC2426) !important;color:#fff !important;border-color:var(--ss-red,#EC2426) !important;border-radius:999px !important;font-weight:700 !important;}' +
    '.jdgm-widget .jdgm-rev{font-family:var(--ss-font-body,"Inter",sans-serif) !important;}' +
    '.jdgm-widget .jdgm-rev__title,' +
    '.jdgm-widget .jdgm-rev-widg__summary-text{font-family:var(--ss-font-display,"Outfit",sans-serif) !important;}'
  );

  function injectCSS() {
    if (document.getElementById('ss-jdgm-css')) return;
    var s = document.createElement('style');
    s.id = 'ss-jdgm-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function getProductId() {
    var pdp = document.querySelector('[data-ss-pdp]');
    return pdp && pdp.getAttribute('data-product-id');
  }

  function triggerJdgmRender() {
    try { document.dispatchEvent(new Event('jdgm-on-change-event')); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent('refresh-jdgm')); } catch (e) {}
    if (window.jdgm && typeof window.jdgm.loadWidget === 'function') {
      try { window.jdgm.loadWidget(); } catch (e) {}
    }
    if (typeof window.jdgmRefreshWidget === 'function') {
      try { window.jdgmRefreshWidget(); } catch (e) {}
    }
  }

  /* ============================================================
     Buy-box rating sync.
     Reads Judge.me's actual rendered count + average and writes them
     into the buy-box rating block, replacing the stale metafield
     numbers. If Judge.me reports zero reviews, hides the rating block.
     ============================================================ */
  function readJdgmAggregate() {
    /* Method 1: read the rendered widget's summary attributes */
    var widget = document.querySelector('.jdgm-widget.jdgm-review-widget');
    if (widget) {
      var n = parseInt(widget.getAttribute('data-number-of-reviews'), 10);
      var a = parseFloat(widget.getAttribute('data-average-rating'));
      if (!isNaN(n) && n >= 0) {
        return { count: n, average: isNaN(a) ? 0 : a };
      }
    }

    /* Method 2: parse the summary text "Based on X reviews" */
    var summary = document.querySelector('.jdgm-rev-widg__summary-text');
    if (summary) {
      var txt = summary.textContent || '';
      var match = txt.match(/(\d[\d,]*)\s*review/i);
      if (match) {
        var cnt = parseInt(match[1].replace(/,/g, ''), 10);
        var avgEl = document.querySelector('.jdgm-rev-widg__summary-average');
        var avg = avgEl ? parseFloat(avgEl.textContent) : 0;
        return { count: cnt, average: isNaN(avg) ? 0 : avg };
      }
    }

    /* Method 3: read the preview badge near the title */
    var badge = document.querySelector('.jdgm-prev-badge');
    if (badge) {
      var bn = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
      var ba = parseFloat(badge.getAttribute('data-average-rating'));
      if (!isNaN(bn) && bn >= 0) {
        return { count: bn, average: isNaN(ba) ? 0 : ba };
      }
    }

    return null;
  }

  function syncBuyBoxRating() {
    var ratingBlock = document.querySelector('.ss-pdp__rating');
    if (!ratingBlock) return false;

    var data = readJdgmAggregate();
    if (!data) return false; /* widget hasn't reported yet; CSS keeps block hidden */

    if (data.count === 0) {
      /* Zero reviews — keep block hidden via CSS default */
      ratingBlock.removeAttribute('data-ss-rating-synced');
      return true;
    }

    /* Has reviews — populate then flip the data attribute to unhide via CSS */
    var valueEl = ratingBlock.querySelector('.ss-pdp__rating-value');
    var countEl = ratingBlock.querySelector('.ss-pdp__rating-count');
    var clipRect = ratingBlock.querySelector('.ss-pdp__stars-clip-rect');
    if (valueEl) valueEl.textContent = data.average.toFixed(1);
    if (countEl) countEl.textContent = '(' + data.count.toLocaleString() + ')';
    if (clipRect) clipRect.setAttribute('width', (data.average / 5 * 108).toFixed(2));

    ratingBlock.setAttribute('data-ss-rating-synced', '1');
    return true;
  }

  function enhance() {
    var reviews = document.querySelector('.ss-pc__reviews');
    if (!reviews || reviews.dataset.ssJdgm === '1') return;

    var productId = getProductId();
    if (!productId) return;

    injectCSS();

    var pager = reviews.querySelector('.ss-pc__rev-pages');
    if (pager) pager.remove();

    var head = reviews.querySelector('.ss-pc__head');
    var wrap = document.createElement('div');
    wrap.className = 'ss-pc__jdgm-wrap';
    wrap.innerHTML =
      '<div class="ss-jdgm-skel"><div class="ss-jdgm-skel__bar"></div><div class="ss-jdgm-skel__bar"></div><div class="ss-jdgm-skel__bar"></div></div>' +
      '<div class="jdgm-widget jdgm-review-widget" data-id="' + productId + '"></div>';

    if (head && head.parentNode === reviews) {
      head.insertAdjacentElement('afterend', wrap);
    } else {
      reviews.appendChild(wrap);
    }

    reviews.dataset.ssJdgm = '1';

    triggerJdgmRender();
    setTimeout(triggerJdgmRender, 400);
    setTimeout(triggerJdgmRender, 1500);
  }

  function initRatingSync() {
    /* Run the sync at intervals until Judge.me reports data, then stop.
       Also re-run on jdgm change events so it picks up updates after pagination. */
    var attempts = 0;
    var maxAttempts = 30; /* ~15s of polling */
    var interval = setInterval(function () {
      attempts++;
      if (syncBuyBoxRating() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 500);

    document.addEventListener('jdgm-on-change-event', syncBuyBoxRating);
    document.addEventListener('jdgm.loaded', syncBuyBoxRating);
    window.addEventListener('load', syncBuyBoxRating);

    /* MutationObserver: when Judge.me populates the widget DOM, sync immediately. */
    if ('MutationObserver' in window) {
      var target = document.querySelector('.ss-pc__jdgm-wrap, .ss-pc__reviews');
      if (target) {
        var mo = new MutationObserver(function () { syncBuyBoxRating(); });
        mo.observe(target, { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhance();
      initRatingSync();
    });
  } else {
    enhance();
    initRatingSync();
  }
  document.addEventListener('shopify:section:load', function () {
    enhance();
    syncBuyBoxRating();
  });
})();
